import { defineNuxtPlugin } from '#app';
import VueExcelEditor from 'vue3-excel-editor'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueExcelEditor)
});